let appJsUrl = "";
const appjs = document.getElementById("appjs");
if (appjs) {
    appJsUrl = new URL(appjs.src).origin;
}

export const baseUrl = appJsUrl;
